import React, { useMemo } from "react";
import { LineChart, Line, ResponsiveContainer, Tooltip, YAxis } from "recharts";

const MiniChart = ({ stock }) => {
  const data = useMemo(() => {
    if (!stock) return [];
    const base = stock?.price;
    return Array.from({ length: 30 }, (_, i) => ({
      t: i,
      price: base * (1 + (Math.sin(i * 0.4 + stock?.id) * 0.05) + (Math.random() - 0.5) * 0.02),
    }));
  }, [stock?.id]);

  if (!stock) return null;
  const isUp = stock?.change >= 0;

  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-3">
        <div>
          <span className="font-heading text-sm font-bold text-foreground">{stock?.ticker}</span>
          <span className="font-body text-xs text-muted-foreground ml-2">{stock?.name}</span>
        </div>
        <div className="text-right">
          <div className="font-data text-lg font-bold text-foreground">${stock?.price?.toFixed(2)}</div>
          <div className={`font-data text-xs font-medium ${isUp ? "text-emerald-400" : "text-red-400"}`}>
            {isUp ? "+" : ""}{stock?.change?.toFixed(2)}%
          </div>
        </div>
      </div>
      <div className="h-24">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <YAxis domain={["auto", "auto"]} hide />
            <Tooltip
              contentStyle={{ background: "var(--color-card)", border: "1px solid var(--color-border)", borderRadius: "8px", fontSize: "11px" }}
              formatter={(v) => [`$${v?.toFixed(2)}`, "Price"]}
              labelFormatter={() => ""}
            />
            <Line type="monotone" dataKey="price" stroke={isUp ? "#34d399" : "#f87171"} strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <div className="grid grid-cols-3 gap-3 mt-3 pt-3 border-t border-border">
        <div>
          <div className="font-caption text-xs text-muted-foreground">Volume</div>
          <div className="font-data text-xs text-foreground">{(stock?.volume / 1000)?.toFixed(1)}K</div>
        </div>
        <div>
          <div className="font-caption text-xs text-muted-foreground">Mkt Cap</div>
          <div className="font-data text-xs text-foreground">${(stock?.marketCap / 1e6)?.toFixed(1)}M</div>
        </div>
        <div>
          <div className="font-caption text-xs text-muted-foreground">Sector</div>
          <div className="font-caption text-xs" style={{ color: stock?.sectorColor }}>{stock?.sector}</div>
        </div>
      </div>
    </div>
  );
};

export default MiniChart;